import type { FaireProductEntity } from "../../entity_types/product";

export const p_2t7d47btrr: FaireProductEntity = {
  token: "p_2t7d47btrr",
  type: "product",
  name: "Floral Hummingbird Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/86c3f76988ffb9549cab80a5aa442ddf6eaf8c10bec62746639d67b3e2038449.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e96f1ad62f7daa13617852c642b308185bbbff71d56c180eadee28c14cd6ba7.jpeg",
    "https://cdn.faire.com/fastly/d3269d2882bf35511104433aeb1e61ea4bc6be65eae1398d9d2f4410f4f11066.jpeg",
    "https://cdn.faire.com/fastly/8bde2ebde72412a45f41f514422b03496f045edc1e4db89a656a789b49496fe6.jpeg",
    "https://cdn.faire.com/fastly/4145b8ed9fca30ef1627a3b4cce88c8d3e87305ea97a8d7c70a8993581b1830f.jpeg",
    "https://cdn.faire.com/fastly/30c9e879bf0d135087586f7f7694b7b89f6f237d1fd438d608890ba76ccc8297.jpeg",
    "https://cdn.faire.com/fastly/7c8c1a22b504c18ba56004e69d5a0c6bc5e64cb51b78b018a31de51e93072dc3.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Botanical Collection featuring an all-over design displaying a pattern of hummingbirds and spring florals. Double-sided towel displays a coordinating mixed floral pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Each spring floral design is replicated from original artwork hand in a watercolor style. Our Floral Hummingbird kitchen towel is conveniently machine washable for easy cleaning. Microfiber towel is packaged on a cardboard hanger with hole to easily display on store rack. A botanical-themed kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:10.789Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
